/**
 * routes/moduleDefs.js -- Port de src/js/modules.js (solo los DATOS,
 * MODULE_DEFS). Deliberadamente separado del componente que los pinta
 * (ModulesGrid.jsx) -- mismo SRP que ya tenia el original: "que modulos
 * existen y quien los puede ver" no es lo mismo que "como se ve la
 * grilla de tarjetas".
 *
 * `permiso` es justo lo que antes era `visible: () => can('...')` --
 * aqui es un dato plano (string) en vez de una funcion, porque el
 * QUIEN pregunta (`can()`) ahora vive en el Context, no aqui. Un
 * modulo ya no necesita saber COMO se pregunta el permiso, solo CUAL.
 */
export const MODULE_DEFS = [
  {
    id: 'bigitem',
    path: '/pedidos',
    icon: 'local_shipping',
    title: 'Pedidos Big Item',
    desc: 'Solicitudes de Big Item y volumen, y sus estadisticas.',
    permiso: 'modulo.bigitem.ver',
  },
  {
    id: 'catalogos',
    path: '/catalogos',
    icon: 'category',
    title: 'Catalogos',
    desc: 'Proveedores, gerentes, subgerentes y catalogos de referencia.',
    permiso: 'modulo.catalogos.ver',
  },
  {
    id: 'tiendas',
    path: '/tiendas',
    icon: 'store',
    title: 'Tiendas',
    desc: 'Consulta de tiendas y de su subgerente Last Mile.',
    permiso: 'modulo.tiendas.ver',
  },
  {
    id: 'adminsistema',
    path: '/admin-sistema',
    icon: 'admin_panel_settings',
    title: 'Administracion del sistema',
    desc: 'Usuarios y su acceso al sistema.',
    permiso: 'modulo.adminsistema.ver',
  },
  {
    id: 'config',
    path: '/config',
    icon: 'tune',
    title: 'Configuracion',
    desc: 'Parametros, horas de corte y automatizacion.',
    permiso: 'modulo.config.ver',
  },
  {
    id: 'reportedrivers',
    path: '/reporte-drivers',
    icon: 'report_problem',
    title: 'Reporte de Drivers',
    desc: 'Incidencias con drivers de proveedores.',
    permiso: 'modulo.reportedrivers.ver',
    // Mismo caso especial que route-guard.js: PROVEEDOR nunca ve este
    // modulo, ni siquiera el "sin acceso" generico (doc 25 SS2.1/RD-1).
    incompatibleWith: ['PROVEEDOR'],
  },
  {
    id: 'notificaciones',
    path: '/notificaciones',
    icon: 'notifications',
    title: 'Notificaciones',
    desc: 'Plantillas de mensaje de Telegram.',
    permiso: 'modulo.notificaciones.ver',
  },
];
